import { render, staticRenderFns } from "./OrdenItemGrupal.vue?vue&type=template&id=4d3f38b8&scoped=true&"
import script from "./OrdenItemGrupal.vue?vue&type=script&lang=js&"
export * from "./OrdenItemGrupal.vue?vue&type=script&lang=js&"
import style0 from "./OrdenItemGrupal.vue?vue&type=style&index=0&id=4d3f38b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3f38b8",
  null
  
)

export default component.exports